export default __webpack_public_path__ + "e4e29c0271836deeb03043cb7e5d88a0.png";